// What each "feature post" shows. Kinds are rendered by FeatureSlideCard.
export const FEATURES = [
  {
    id: "transpose",
    title: "Transpose",
    tag: "Editing",
    slides: [
      { kind: "notation", caption: "The tune as it is on thesession.org" },
      { kind: "abc", caption: "Tap − or + : the ABC is rewritten in the new key", badge: "+2 semitones" },
      { kind: "notation", transpose: 2, caption: "The same tune two semitones up — ready to play" },
    ],
    bullets: [
      "Every note respelled in the destination key, like a copyist would",
      "Accidentals, grace notes, chords and repeats all follow",
      "Your transposed version can be saved and printed",
    ],
  },
  {
    id: "export",
    title: "Print-perfect sheet music",
    tag: "Export",
    slides: [
      { kind: "export", caption: "Real A4 preview, fitted to a single page" },
      { kind: "export-landscape", caption: "Landscape when the tune is wide" },
      { kind: "bullets", caption: "Zoom from 50% to 200%, or let Fit do the work" },
    ],
    bullets: [
      "Vector PDF, so it stays sharp at any size",
      "Your own line breaks are respected",
      "Fit works across several pages, not just the first",
    ],
  },
  {
    id: "abc",
    title: "The ABC editor, explained",
    tag: "Editing",
    slides: [
      { kind: "abc", caption: "Edit the plain text — notation and player follow instantly" },
      { kind: "screen-abcguide", caption: "Reading & writing ABC — the guide behind the editor's ⓘ button" },
    ],
    bullets: [
      "Change a setting, fix a bar, keep your own version",
      "Tap the ⓘ for the full ABC cheat-sheet",
      "Works on a phone, no software to install",
    ],
  },
  {
    id: "fame",
    title: "Search a tune by Fame",
    tag: "Search",
    slides: [
      { kind: "screen-fame", zoom: 0.8, caption: "One slider: from hidden gems to session anthems" },
      { kind: "screen-info", zoom: 0.7, caption: "Tap Info: how the score is built — and tell us if it feels wrong" },
      { kind: "notation", caption: "Every search reshuffles — there is always something new" },
    ],
    bullets: [
      "Fame is computed from settings, recordings, tunebooks and sets",
      "Open the ⓘ on any tune to see exactly how its score was built",
      "Disagree? Signed-in players can contest it, up to ±10 points",
    ],
  },
  {
    id: "name",
    title: "Search by name, type, key, notes or link",
    tag: "Search",
    slides: [
      { kind: "screen-name", caption: "By name: half a title is enough — aliases are searched too" },
      { kind: "screen-typekey", caption: "By type and key: every rhythm and mode, A to Z" },
      { kind: "screen-notes", caption: "By notes: type a few in ABC, like FAA BAA" },
      { kind: "screen-link", caption: "By link: paste a track, get its tunes — then browse the album" },
      { kind: "bullets", caption: "Five ways in, one search box" },
    ],
    bullets: [
      "Every alternative title is matched, not just the main one",
      "Notes search ignores octaves and note lengths, and opens the version that has them",
      "Paste a Tidal, YouTube, Spotify, Apple Music, Deezer or Bandcamp link",
      "Clear the box with one tap on the ×",
    ],
  },
  {
    id: "link",
    title: "Paste a track, find its tunes",
    tag: "Search",
    slides: [
      { kind: "screen-sources", caption: "Works with the music apps you already use" },
      { kind: "screen-link", caption: "The exact tunes of that track, from thesession.org recordings" },
      { kind: "screen-album", caption: "← → walk through the album, track by track" },
      { kind: "screen-tunelinks", caption: "The tune remembers the link you found it with — tap to copy" },
      { kind: "bullets", caption: "Heard it at a gig? Paste, play, learn" },
    ],
    bullets: [
      "Artist, album and track number are read from the link",
      "Matched against every recording listed on thesession.org",
      "Track not listed? The tune names in its title are searched instead",
      "Saved to your account, so the link is there on every device",
    ],
  },
  {
    id: "flags",
    title: "Favourites and colour flags",
    tag: "Practice",
    slides: [{ kind: "flags", caption: "Your practice list, by colour and by tune type" }],
    bullets: [
      "Flags and favourites live on the exact version you saved",
      "Your edited settings come back with your edits",
      "Premium members create as many colours as they like — free members keep the four",
    ],
  },
  {
    id: "expert",
    title: "Ask the expert",
    tag: "AI",
    slides: [
      { kind: "analysis", caption: "Composer, era, region, first recording and the real story" },
      { kind: "bullets", caption: "What is known, what is not, and where it comes from" },
    ],
    bullets: [
      "Get the most relevant information about the tune",
      "Already studied? It opens with the tune, free for everyone",
      "Sources include what people say about the tune on the web",
      "Packs of 50 or 120 analyses for the deep divers",
    ],
  },
  {
    id: "rarity",
    title: "Verify rarity",
    tag: "Search",
    slides: [{ kind: "rarity", caption: "Is your rare find a session standard under another name?" }],
    bullets: [
      "Catches the same tune hiding behind a different title",
      "Free, instant, no sign-in needed",
    ],
  },
  {
    id: "player",
    title: "Hear it before you learn it",
    tag: "Player",
    slides: [
      { kind: "player", caption: "Play it, slow it down, loop the hard bar" },
      { kind: "bullets", caption: "The notes light up as they sound" },
    ],
    bullets: [
      "Set the tempo to your own speed, with a metronome if you want one",
      "Zoom the notation or go full screen on a music stand",
      "Works on any phone — nothing to install",
    ],
  },
  {
    id: "pricing",
    title: "Free, and fair",
    tag: "Plans",
    slides: [
      { kind: "pricing", caption: "Everything you need is free. Premium pays the hosting." },
      { kind: "bullets", caption: "Cancel in two clicks, keep access to the end of the period" },
    ],
    bullets: [
      "Guests: 5 searches a day. Signed in: 20 a day, free",
      "Premium: unlimited searches and monthly expert analyses",
      "No advertising, no tracking, no selling of your data",
    ],
  },
  {
    id: "install",
    title: "Put Foinn.org on your phone",
    tag: "Setup",
    slides: [
      { kind: "install", caption: "Three taps on iPhone, three on Android" },
      { kind: "bullets", caption: "A real app icon, no app store" },
    ],
    bullets: [
      "Opens full screen, straight to the search box",
      "Keeps your favourites and flags on the device",
      "Nothing to update, ever",
    ],
  },
  {
    id: "faq",
    title: "Frequently asked",
    tag: "FAQ",
    slides: [
      {
        kind: "faq",
        caption: "The questions players ask us most",
        items: [
          ["Where do the tunes come from?", "From the open data of thesession.org — settings, recordings, sets and tunebooks, refreshed regularly."],
          ["Do I need an account?", "No. Guests get 5 searches a day; signing in with Google makes it 20 and unlocks favourites and flags."],
          ["Can I print the music?", "Yes — a real vector PDF, in portrait or landscape, fitted to the page."],
          ["Can I find the tunes of a track I heard?", "Paste its Tidal, YouTube, Spotify, Apple Music, Deezer or Bandcamp link in the search box."],
        ],
      },
      {
        kind: "faq",
        caption: "And the ones about money",
        items: [
          ["Is it really free?", "Yes. Premium (€2 a month or €20 a year) pays for hosting, the domain and the AI."],
          ["What is an expert analysis?", "A researched note about the tune's origin, era and recordings. Already-studied tunes are free for everyone."],
          ["How do I cancel?", "Two clicks in Your account. You keep premium until the end of the paid period."],
        ],
      },
    ],
    bullets: [
      "Every answer is on foinn.org/about",
      "Write to us if yours is not there",
    ],
  },
  {
    id: "about",
    title: "Every answer in one page",
    tag: "Guide",
    slides: [
      { kind: "about", caption: "foinn.org/about — guides, pricing, install and FAQ" },
      { kind: "bullets", caption: "Start here if you are new to Foinn.org" },
    ],
    bullets: [
      "A short guide to every feature, with examples",
      "Plans, add-on packs and what your money pays for",
      "How to install it on your phone in three taps",
    ],
  },
];

export const BADGES = {
  logo: "Logo only",
  domain: "Logo + Foinn.org",
  full: "Logo + Foinn.org + Folk Tune Finder",
};
